import EditUserProfile from './EditUserProfile';

export default EditUserProfile;
